import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Archive } from "@phosphor-icons/react";

export default function BulkConfirmDialog({ action, count, onCancel, onConfirm }) {
  const isClose = action === "close";
  return (
    <Dialog open={!!action} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-md rounded-md" data-testid="bulk-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            {isClose ? <CheckCircle size={20} weight="bold" /> : <Archive size={20} weight="bold" />}
            {isClose ? "Clôturer les tickets" : "Archiver les tickets"}
          </DialogTitle>
          <DialogDescription>
            {isClose
              ? `Vous êtes sur le point de clôturer ${count} ticket(s). Les clients concernés recevront une notification.`
              : `Vous êtes sur le point d'archiver ${count} ticket(s). Seuls les tickets déjà clôturés seront archivés (les autres seront ignorés).`}
            {" "}Confirmer&nbsp;?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-row justify-end gap-2">
          <Button variant="outline" className="rounded-sm h-9 border-zinc-300" onClick={onCancel} data-testid="bulk-confirm-cancel">Annuler</Button>
          <Button className="bg-zinc-900 hover:bg-zinc-800 text-white rounded-sm h-9 gap-1.5" onClick={onConfirm} data-testid="bulk-confirm-ok">
            {isClose ? <CheckCircle size={15} weight="bold" /> : <Archive size={15} weight="bold" />}
            {isClose ? "Clôturer" : "Archiver"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
